export const APP_NAME = 'Store Credit App™';